import React from 'react';
import LabelClaro from './LabelClaro';

class CustomInputClaro extends React.Component {

    render() {
        let wrapperClass = this.props.componentClassName;
        let mensajeHTML = this.props.error ? this.props.error : ''
        let spanIconClass = 'input-group-addon error-icon hide';
        if (this.props.error !== undefined && this.props.error !== null) {
            wrapperClass += ' has-error';
            spanIconClass = 'input-group-addon error-icon';
        }

        return (
            <div className={ wrapperClass }>
                
             { (this.props.labelText||this.props.htmlText) && <LabelClaro
                    htmlFor={this.props.idElement}
                    labelInf={this.props.labelInf}
                    labelText={this.props.labelText}
                    labelTip={this.props.labelTip}
                    className={this.props.labelClassName}
                    htmlText={this.props.htmlText}
                /> }

                <div className={this.props.inputClassName}>
                    <input
                        id={this.props.idElement}
                        name={this.props.idElement}
                        type={this.props.inputType}
                        className="form-control"
                        placeholder={this.props.placeholderText}
                        value={this.props.value}
                        onChange={this.props.onChange}
                        minLength={this.props.minLength}
                        maxLength={this.props.maxLength}
                        disabled={(this.props.disabled) ? true : false}
                    />
                    <span className={ spanIconClass }>
                        <i className="fa fa-exclamation-triangle"></i>
                    </span>
                    <span className="help-block error-wrapper error-invalid" dangerouslySetInnerHTML={{__html: mensajeHTML}}></span>
                    {this.props.additionalMessage}
                </div>
            </div>
        );
    }

}


CustomInputClaro.propTypes = {};

CustomInputClaro.defaultProps = {
    componentClassName : "",
    labelClassName: "",
    inputClassName: "",
    additionalMessage : "",
    disabled:false
}

export default CustomInputClaro


